// One museum-label card for every painting, in every room, 3D or 2D: opaque cream, dark ink, the same sizes everywhere.
const firstSentence = (t) => ((t || "").split(/(?<=[.!?])\s+/)[0] || "").slice(0, 150);

export const STORY_CARD_W = 248;

export function StoryCard({ painting, cardRef, style, className = "", testid = "room-story-card" }) {
  const excerpt = firstSentence(painting.about);
  return (
    <aside
      ref={cardRef}
      data-testid={testid}
      style={{ width: STORY_CARD_W, ...style }}
      className={`story-card rounded-lg border border-[#E4D8C4] bg-[#FBF6EC] px-3.5 py-2.5 text-left shadow-[0_14px_34px_-22px_rgba(45,30,62,0.6)] ${className}`}
    >
      <p data-testid="story-card-title" className="font-display text-lg italic leading-tight text-[#24182F]">{painting.title}</p>
      <p className="mt-0.5 text-[10px] uppercase tracking-[0.22em] text-[#5F5249]">Priyanka Jha · Acrylic on canvas</p>
      {painting.style?.trim() && <p data-testid="story-card-style" className="mt-1.5 line-clamp-2 font-display text-[12.5px] italic leading-snug text-[#5F5249]">{painting.style}</p>}
      {(excerpt || painting.note) && (
        <p data-testid="story-card-story" className="mt-1.5 font-display text-[12.5px] leading-snug text-[#2A1F33]">
          {excerpt && <span className="line-clamp-2">{excerpt}</span>}
          {painting.note?.trim() && <span data-testid="story-card-line" className="mt-0.5 block italic text-[#24182F]">{painting.note}</span>}
        </p>
      )}
    </aside>
  );
}
